import axios from 'axios';
import { environment } from 'environments/environment';

export interface CustomerRequestBody {
    customer: string;
    project: string;
    vehicle: string;
}

export interface FileString {
    file: File;
    name: string;
    size: number;
}

export const addEntry = async (requestBody: CustomerRequestBody) => {
    const response = await axios.post(`${environment.apiBaseUrl}upload-file/add`, requestBody, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${environment.authToken}`
        }
    });

    return true;
};

export const uploadFile = async (file: FormData) => {
    const response = await axios.post(`${environment.apiBaseUrl}upload-file/upload`, file, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${environment.authToken}`
        }
    });

    return response;
};

export const getOnlineAsync = async (tcu: any) => {
    let res: any;

    let body = {
        TCU: tcu
    };

    const getOnline = async () => {
        await axios
            .post(`${environment.apiBaseUrl}upload-file/getOnline`, body, {
                headers: {
                    Authorization: `Bearer ${environment.authToken}`
                }
            })
            .then((response) => {
                res = response.data;
                return res;
            })
            .catch((err) => {
                console.log(err);
                console.log(err.message);
                console.log(err.code);
                throw err;
            });
    };
    await getOnline();
    return res;
};

export const getDMAsync = async (tcu: any) => {
    let res: any;

    let body = {
        TCU: tcu
    };

    const getDM = async () => {
        await axios
            .post(`${environment.apiBaseUrl}upload-file/getDM`, body, {
                headers: {
                    Authorization: `Bearer ${environment.authToken}`
                }
            })
            .then((response) => {
                res = response.data;
                return res;
            })
            .catch((err) => {
                console.log(err);
                console.log(err.message);
                console.log(err.code);
                throw err;
            });
    };
    await getDM();
    return res;
};

export default addEntry;
